// Team canvas (/team-and-agents): unassigning an agent from a person asks
// first (CRUD + confirm standard rule 4; audit row "team canvas — Agent
// assignment"). Two triggers reach it: a click on the agent → person edge on
// the board, and the Remove button in the agent editor's Assignment tab. Both
// used to unassign on the click.
//
// el.call('confirmAgentUnassign', { agent, person, onConfirm }) opens the house
// confirm (confirmDialog) that names the agent and the person. The caller's
// unassign runs only in onConfirm; nothing changes before the verb.

// Fill one {token} with a literal value. A function replacer, so a `$&` or a
// `$$` inside a name is never read as a replacement pattern.
const _agentUnassignFill = (text, token, value) => String(text).replace(token, () => String(value))

export const confirmAgentUnassign = function (ask) {
  const { agent, person, onConfirm } = ask || {}
  if (!agent || !person || typeof onConfirm !== 'function') return
  const fill = (key) =>
    _agentUnassignFill(
      _agentUnassignFill(this.call('polyglot', key), '{agent}', agent),
      '{person}',
      person
    )
  this.call('confirmDialog', {
    title: fill('canvas.team.unassign.title'),
    message: fill('canvas.team.unassign.message'),
    confirmText: this.call('polyglot', 'canvas.team.unassign.confirm'),
    cancelText: this.call('polyglot', 'common.action.cancel'),
    confirmTheme: 'primary',
    // `null` is the explicit opt-out; OMITTING the key takes the template's
    // 'warning' default.
    icon: null,
    onConfirm
  })
}
